// frontend/src/pages/LandingPage.jsx
import { useState, useEffect } from 'react';
import { GlobalStyles } from '@bigcommerce/big-design';
import {
  ShoppingCart,
  CheckCircle,
  Zap,
  ShoppingBag,
  PlusCircle,
  DollarSign,
  Check,
  RefreshCw,
  Percent,
  Layers,
  ShieldCheck,
  Download,
  Settings,
  CreditCard,
  Package,
  Leaf,
  Globe,
  AlertTriangle,
  Box,
  Tag,
  Users,
  Folder,
  Monitor,
  Menu,
  X,
} from 'lucide-react';

// BigCommerce wordmark logo component
const BigCommerceLogo = ({ height = 40, color = '#6b7280' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="65 110 550 120"
    height={height}
    fill={color}
    style={{ display: 'inline-block', verticalAlign: 'middle', marginBottom: '20px' }}
  >
    <g>
      <g>
        <path d="M201.1,174.5c7.3,0,12.2,3.3,15.2,7.4v-58.4c0-1.1-1.3-1.8-2.2-1.1L142,175.1h1.9c7.5,0,11.3,4.8,11.3,10c0,4.1-2.1,7.1-5,8.4c-0.5,0.2-0.5,0.9,0,1.1c3.3,1.4,5.7,4.9,5.7,9.1c0,6-3.9,10.7-11.4,10.7H124c-0.4,0-0.8-0.3-0.8-0.8v-24.8l-53.7,39.3c-0.9,0.8-0.5,2.2,0.7,2.2h144.8c0.7,0,1.2-0.5,1.2-1.2v-19.9c-3.9,3.6-9,5.9-15.2,5.9c-11.6,0-21-8-21-20.3C180.1,182.4,189.6,174.5,201.1,174.5z M172.4,213.7c0,0.4-0.3,0.7-0.7,0.7h-6.9c-0.4,0-0.7-0.3-0.7-0.7v-37.9c0-0.4,0.3-0.7,0.7-0.7h6.9c0.4,0,0.7,0.3,0.7,0.7V213.7z"/>
      </g>
      <path d="M132.4,190.7h9.7c2.8,0,4.6-1.6,4.6-4.1c0-2.4-1.8-4.1-4.6-4.1H132c-0.2,0-0.4,0.2-0.4,0.4v7.1C131.6,190.4,132,190.7,132.4,190.7z"/>
      <path d="M132.4,207.1h10.1c3.1,0,5-1.7,5-4.5c0-2.5-1.8-4.5-5-4.5h-10.1c-0.4,0-0.8,0.3-0.8,0.8v7.4C131.6,206.7,132,207.1,132.4,207.1z"/>
      <path d="M210,186.4c-1.9-2.5-5.1-4.5-8.9-4.5c-7.2,0-12.4,5.5-12.4,12.9c0,7.4,5.2,12.9,12.4,12.9c3.3,0,6.4-1.4,8.1-2.8c0.1-0.1,0.2-0.3,0.2-0.5v-3.8c0-0.3-0.3-0.6-0.6-0.6h-8.9c-0.5,0-0.8-0.4-0.8-0.8v-5.6c0-0.5,0.4-0.8,0.8-0.8h16.5v-8.9l-5.3,2.9C210.7,186.9,210.2,186.7,210,186.4z"/>
      <path d="M222.5,194.8c0-12.1,8.7-20.3,19.9-20.3c7.3,0,12,3.7,14.8,8.2c0.2,0.3,0.1,0.8-0.3,0.9l-4.5,2.4c-0.3,0.2-0.7,0.1-0.8-0.2c-1.9-3-5.4-5.2-9.2-5.2c-7.5,0-13.1,5.9-13.1,14.2c0,8.2,5.6,14.2,13.1,14.2c3.8,0,7.3-2.2,9.2-5.2c0.2-0.3,0.5-0.4,0.8-0.2l4.5,2.3c0.4,0.2,0.5,0.6,0.3,1c-2.9,4.5-7.6,8.3-14.8,8.3C231.2,215.1,222.5,206.8,222.5,194.8z"/>
      <path d="M261.1,194.8c0-9.8,5.6-17.4,14-19.6c14.3-3.8,27.4,9.6,24.3,24.5c-1.9,9.2-9.2,15.5-18.9,15.5C269.1,215.1,261.1,206.5,261.1,194.8z M293,194.8c0-8.1-5-14.2-12.6-14.2c-7.7,0-12.6,6.1-12.6,14.2c0,8.1,4.9,14.2,12.6,14.2C288.1,209,293,202.8,293,194.8z"/>
      <path d="M340.6,213.9V184l-11.9,30.1c0,0.1-0.2,0.2-0.3,0.2h-2.5c-0.1,0-0.3-0.1-0.3-0.2l-12-30.1v29.9c0,0.3-0.2,0.5-0.5,0.5h-6c-0.3,0-0.5-0.2-0.5-0.5v-38.4c0-0.3,0.2-0.5,0.5-0.5h8.6c0.4,0,0.7,0.2,0.9,0.6l10.5,27l10.4-27c0.1-0.4,0.5-0.6,0.9-0.6h8.6c0.3,0,0.5,0.2,0.5,0.5v38.4c0,0.3-0.2,0.5-0.5,0.5h-6C340.9,214.4,340.6,214.2,340.6,213.9z"/>
      <path d="M408.6,213.7v-37.9c0-0.4,0.3-0.7,0.7-0.7h25.5c0.4,0,0.7,0.3,0.7,0.7v4.6c0,0.4-0.3,0.7-0.7,0.7h-18.6c-0.4,0-0.7,0.3-0.7,0.7v8.7c0,0.4,0.3,0.7,0.7,0.7h18.2c0.4,0,0.7,0.3,0.7,0.7v4.6c0,0.4-0.3,0.7-0.7,0.7h-18.2c-0.4,0-0.7,0.3-0.7,0.7v9.5c0,0.4,0.3,0.7,0.7,0.7h18.6c0.4,0,0.7,0.3,0.7,0.7v4.6c0,0.4-0.3,0.7-0.7,0.7h-25.5C408.9,214.4,408.6,214.1,408.6,213.7z"/>
      <path d="M467.5,214l-8.3-14c-0.1-0.2-0.4-0.3-0.6-0.3h-5.8c-0.4,0-0.7,0.3-0.7,0.7v13.3c0,0.4-0.3,0.7-0.7,0.7H446c-0.4,0-0.7-0.3-0.7-0.7v-37.9c0-0.4,0.3-0.7,0.7-0.7h16.6c7.8,0,12.9,5,12.9,12.3c0,6.5-4,10.2-8.4,11.3c-0.5,0.1-0.7,0.6-0.5,1.1c1.6,2.6,6.6,10.6,8.5,13.5c0.3,0.5,0,1.1-0.6,1.1h-6.3C467.9,214.4,467.7,214.3,467.5,214z M468.4,187.3c0-3.8-2.8-6.2-6.7-6.2h-8.8c-0.4,0-0.7,0.3-0.7,0.7v11.1c0,0.4,0.3,0.7,0.7,0.7h8.8C465.6,193.6,468.4,191.2,468.4,187.3z"/>
      <path d="M522.1,213.7v-37.9c0-0.4,0.3-0.7,0.7-0.7h25.6c0.4,0,0.7,0.3,0.7,0.7v4.7c0,0.4-0.3,0.7-0.7,0.7h-18.7c-0.4,0-0.7,0.3-0.7,0.7v8.8c0,0.4,0.3,0.7,0.7,0.7h18.2c0.4,0,0.7,0.3,0.7,0.7v4.7c0,0.4-0.3,0.7-0.7,0.7h-18.2c-0.4,0-0.7,0.3-0.7,0.7v9.6c0,0.4,0.3,0.7,0.7,0.7h18.7c0.4,0,0.7,0.3,0.7,0.7v4.7c0,0.4-0.3,0.7-0.7,0.7h-25.6C522.4,214.4,522.1,214.1,522.1,213.7z"/>
      <path d="M480.5,194.6c0-12.1,8.7-20.3,19.9-20.3c7.3,0,12,3.7,14.8,8.2c0.2,0.3,0.1,0.8-0.3,0.9l-4.5,2.4c-0.3,0.2-0.7,0.1-0.8-0.2c-1.9-3-5.4-5.2-9.2-5.2c-7.5,0-13.1,5.9-13.1,14.2c0,8.2,5.6,14.2,13.1,14.2c3.8,0,7.3-2.2,9.2-5.2c0.2-0.3,0.5-0.4,0.8-0.2l4.5,2.3c0.4,0.2,0.5,0.6,0.3,1c-2.9,4.5-7.6,8.3-14.8,8.3C489.2,214.9,480.5,206.7,480.5,194.6z"/>
      <path d="M391.6,213.9V184l-11.9,30.1c0,0.1-0.2,0.2-0.3,0.2h-2.5c-0.1,0-0.3-0.1-0.3-0.2l-12-30.1v29.9c0,0.3-0.2,0.5-0.5,0.5h-6c-0.3,0-0.5-0.2-0.5-0.5v-38.4c0-0.3,0.2-0.5,0.5-0.5h8.6c0.4,0,0.7,0.2,0.9,0.6l10.5,27l10.4-27c0.1-0.4,0.5-0.6,0.9-0.6h8.6c0.3,0,0.5,0.2,0.5,0.5v38.4c0,0.3-0.2,0.5-0.5,0.5h-6C391.8,214.4,391.6,214.2,391.6,213.9z"/>
    </g>
  </svg>
);

// Color palette from design
const colors = {
  indigo50: '#eef2ff',
  indigo100: '#e0e7ff',
  indigo200: '#c7d2fe',
  indigo400: '#818cf8',
  indigo500: '#6366f1',
  indigo600: '#4f46e5',
  indigo900: '#312e81',
  purple50: '#faf5ff',
  purple400: '#c084fc',
  purple600: '#9333ea',
  gray50: '#f9fafb',
  gray100: '#f3f4f6',
  gray200: '#e5e7eb',
  gray300: '#d1d5db',
  gray400: '#9ca3af',
  gray500: '#6b7280',
  gray600: '#4b5563',
  gray700: '#374151',
  gray800: '#1f2937',
  gray900: '#111827',
  green100: '#dcfdf3',
  green500: '#22c55e',
  green600: '#16a34a',
  white: '#ffffff',
};

const gradients = {
  primary: 'linear-gradient(to right, #4f46e5, #9333ea)',
  hero: 'linear-gradient(to bottom right, #eef2ff, #faf5ff, #eef2ff)',
  card: 'linear-gradient(to bottom right, #eef2ff, #faf5ff)',
  text: 'linear-gradient(to right, #818cf8, #c084fc)',
};

const styles = {
  // Base
  page: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    color: colors.gray900,
    backgroundColor: colors.white,
    margin: '-2rem',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },

  // Hero Section
  hero: {
    background: gradients.hero,
    padding: '3rem',
    position: 'relative',
    overflow: 'hidden',
    minHeight: '800px',
    display: 'flex',
    alignItems: 'center',
  },
  heroContainer: {
    maxWidth: '80rem',
    margin: '0 auto',
    width: '100%',
  },

  // Navigation
  nav: {
    position: 'absolute',
    top: '2rem',
    left: 0,
    right: 0,
    zIndex: 50,
    display: 'flex',
    justifyContent: 'center',
    padding: '0 2rem',
  },
  navInner: {
    display: 'flex',
    width: '100%',
    maxWidth: '80rem',
    padding: '2rem 1.5rem',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  logoIcon: {
    width: '2rem',
    height: '2rem',
    background: colors.white,
    borderRadius: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
  },
  logoText: {
    fontSize: '1.125rem',
    fontWeight: 700,
    letterSpacing: '-0.025em',
    color: colors.gray900,
  },
  navLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    fontSize: '0.875rem',
    fontWeight: 600,
    color: colors.gray900,
  },
  navLink: {
    color: colors.gray900,
    textDecoration: 'none',
    transition: 'color 0.2s',
    cursor: 'pointer',
  },
  navRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
  },
  navButton: {
    background: gradients.primary,
    color: colors.white,
    padding: '0.625rem 1.5rem',
    borderRadius: '9999px',
    fontSize: '0.75rem',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    transition: 'transform 0.2s',
    textDecoration: 'none',
  },

  // Mobile Navigation
  hamburger: {
    display: 'none',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0.5rem',
  },
  mobileMenu: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: colors.white,
    zIndex: 100,
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem',
  },
  mobileMenuHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '3rem',
  },
  mobileMenuClose: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0.5rem',
  },
  mobileMenuLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  mobileMenuLink: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: colors.gray900,
    textDecoration: 'none',
    padding: '0.75rem 0',
    borderBottom: `1px solid ${colors.gray100}`,
  },
  mobileMenuButton: {
    background: gradients.primary,
    color: colors.white,
    padding: '1rem 2rem',
    borderRadius: '9999px',
    fontSize: '1rem',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    marginTop: '2rem',
    textAlign: 'center',
    textDecoration: 'none',
  },

  // Hero Content
  heroGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '4rem',
    alignItems: 'center',
    width: '100%',
    marginTop: '3rem',
  },
  heroLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem',
    position: 'relative',
    zIndex: 10,
  },
  badges: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    flexWrap: 'wrap',
  },
  verifiedBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    background: gradients.primary,
    color: colors.white,
    padding: '0.5rem 1rem',
    borderRadius: '9999px',
    fontSize: '0.75rem',
    fontWeight: 700,
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
  },
  installsBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    background: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(4px)',
    padding: '0.5rem 1rem',
    borderRadius: '9999px',
    fontSize: '0.75rem',
    fontWeight: 700,
    color: colors.gray700,
    boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  },
  pulseDot: {
    width: '0.5rem',
    height: '0.5rem',
    background: colors.green500,
    borderRadius: '9999px',
  },
  heroTitle: {
    fontSize: '68px',
    lineHeight: 0.9,
    letterSpacing: '-0.025em',
    color: colors.gray900,
    fontWeight: 700,
    margin: 0,
    marginBottom: '24px',
  },
  heroTitleItalic: {
    fontSize: '48px',
    color: colors.gray500,
    fontWeight: 400,
  },
  heroContent: {
    maxWidth: '38rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  heroDescription: {
    fontSize: '1.3rem',
    fontWeight: 600,
    lineHeight: '1.8rem',
    color: colors.gray800,
    margin: 0,
  },
  featureRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1rem',
    paddingTop: '1rem',
    borderTop: `1px solid ${colors.gray200}`,
  },
  featureIcon: {
    width: '2.5rem',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: colors.indigo100,
    borderRadius: '9999px',
    flexShrink: 0,
  },
  featureText: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: colors.gray800,
    margin: 0,
  },
  featureSubtext: {
    color: colors.gray500,
    fontWeight: 500,
  },
  heroButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    paddingTop: '1rem',
  },
  primaryButton: {
    background: gradients.primary,
    color: colors.white,
    padding: '1.25rem 2.5rem',
    borderRadius: '9999px',
    fontWeight: 700,
    fontSize: '0.875rem',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    transition: 'transform 0.2s',
  },
  secondaryButton: {
    background: colors.white,
    border: `1px solid ${colors.gray200}`,
    color: colors.gray900,
    padding: '1.25rem 2.5rem',
    borderRadius: '9999px',
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    transition: 'background 0.2s',
  },

  // Order Summary Card
  heroRight: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  orderCard: {
    position: 'relative',
    width: '380px',
    aspectRatio: '4/5',
    borderRadius: '40px',
    boxShadow: '0 25px 50px -12px rgb(0 0 0 / 0.25)',
    background: colors.white,
    border: `4px solid ${colors.gray100}`,
  },
  orderCardInner: {
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '1.5rem',
  },
  orderHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.gray200}`,
    paddingBottom: '1rem',
  },
  orderTitle: {
    fontSize: '0.875rem',
    fontWeight: 700,
    color: colors.gray900,
  },
  orderLines: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  orderLine: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.875rem',
  },
  orderLabel: {
    color: colors.gray600,
  },
  orderValue: {
    fontWeight: 600,
    color: colors.gray900,
  },
  feeLine: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.875rem',
    background: `linear-gradient(to right, ${colors.indigo50}, ${colors.purple50})`,
    margin: '0 -0.5rem',
    padding: '0.5rem',
    borderRadius: '0.5rem',
    border: `1px solid ${colors.indigo100}`,
  },
  feeLabel: {
    color: colors.indigo900,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  feeValue: {
    fontWeight: 700,
    color: colors.indigo900,
  },
  orderTotal: {
    borderTop: `1px solid ${colors.gray200}`,
    paddingTop: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  totalLabel: {
    fontSize: '1.125rem',
    fontWeight: 700,
    color: colors.gray900,
  },
  totalValue: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: colors.gray900,
  },
  completeButton: {
    width: '100%',
    background: colors.gray900,
    color: colors.white,
    padding: '1rem',
    borderRadius: '1rem',
    fontSize: '0.875rem',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },

  // Floating Pills
  floatingPill: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '0.75rem 1.5rem',
    borderRadius: '9999px',
    boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1)',
    fontSize: '0.875rem',
    fontWeight: 700,
  },
  feeAddedPill: {
    top: '2.5rem',
    left: '-1rem',
    background: gradients.primary,
    color: colors.white,
  },
  percentPill: {
    bottom: '5rem',
    left: '9rem',
    background: colors.white,
    border: `1px solid ${colors.gray100}`,
    color: colors.gray900,
    fontSize: '0.75rem',
  },
  fixedRatePill: {
    bottom: '1rem',
    left: '20rem',
    background: colors.white,
    border: `1px solid ${colors.gray100}`,
    color: colors.gray900,
    fontSize: '0.75rem',
  },
  persistentPill: {
    bottom: '4rem',
    right: '-2rem',
    background: colors.white,
    border: `1px solid ${colors.gray100}`,
    color: colors.gray900,
    fontSize: '0.75rem',
  },
  pillIcon: {
    width: '1.5rem',
    height: '1.5rem',
    background: colors.white,
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.75rem',
  },
  checkIcon: {
    width: '1.25rem',
    height: '1.25rem',
    background: colors.green100,
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.625rem',
    color: colors.green600,
  },

  // Decorative blurs
  blur1: {
    position: 'absolute',
    zIndex: -10,
    top: '25%',
    right: '25%',
    width: '24rem',
    height: '24rem',
    background: '#a5b4fc',
    filter: 'blur(120px)',
    opacity: 0.2,
  },
  blur2: {
    position: 'absolute',
    zIndex: -10,
    bottom: '25%',
    left: '25%',
    width: '24rem',
    height: '24rem',
    background: '#d8b4fe',
    filter: 'blur(120px)',
    opacity: 0.2,
  },

  // Features Section
  section: {
    padding: '8rem 1.5rem',
    background: colors.white,
  },
  sectionGray: {
    padding: '8rem 1.5rem',
    background: colors.gray50,
    borderTop: `1px solid ${colors.gray200}`,
    borderBottom: `1px solid ${colors.gray200}`,
  },
  sectionContainer: {
    maxWidth: '80rem',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',
  },
  sectionHeader: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  sectionBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    background: colors.indigo50,
    padding: '0.5rem 1rem',
    borderRadius: '9999px',
    alignSelf: 'center',
  },
  sectionBadgeNumber: {
    width: '1.5rem',
    height: '1.5rem',
    background: gradients.primary,
    color: colors.white,
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.75rem',
    fontWeight: 700,
  },
  sectionBadgeText: {
    fontSize: '0.75rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    color: colors.indigo900,
  },
  sectionTitle: {
    fontSize: '3.75rem',
    fontWeight: 700,
    letterSpacing: '-0.025em',
    color: colors.gray900,
    margin: 0,
  },
  sectionTitleMuted: {
    color: colors.gray500,
  },
  sectionDescription: {
    fontSize: '1.25rem',
    color: colors.gray600,
    maxWidth: '42rem',
    margin: '0 auto',
  },

  // Feature Cards
  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '2rem',
  },
  featureCard: {
    background: colors.white,
    border: `1px solid ${colors.gray200}`,
    borderRadius: '40px',
    padding: '2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    transition: 'all 0.2s',
    cursor: 'default',
  },
  featureCardIcon: {
    width: '3.5rem',
    height: '3.5rem',
    background: gradients.primary,
    borderRadius: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.75rem',
    color: colors.white,
  },
  featureCardTitle: {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: colors.gray900,
    margin: 0,
  },
  featureCardDescription: {
    fontSize: '0.875rem',
    color: colors.gray600,
    lineHeight: 1.625,
    margin: 0,
  },

  // Steps Section
  stepsContainer: {
    maxWidth: '64rem',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',
  },
  step: {
    display: 'flex',
    gap: '3rem',
  },
  stepNumber: {
    fontSize: '4.5rem',
    fontWeight: 700,
    color: colors.gray200,
    lineHeight: 1,
  },
  stepContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    flex: 1,
  },
  stepHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  stepIcon: {
    width: '3rem',
    height: '3rem',
    background: gradients.primary,
    borderRadius: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    color: colors.white,
  },
  stepTitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: colors.gray900,
    margin: 0,
  },
  stepDescription: {
    color: colors.gray600,
    lineHeight: 1.625,
    maxWidth: '36rem',
    margin: 0,
  },

  // Use Cases
  useCasesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '2rem',
  },
  useCaseCard: {
    background: gradients.card,
    border: `1px solid ${colors.indigo100}`,
    borderRadius: '8px',
    padding: '1.3rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  useCaseIcon: {
    width: '3rem',
    height: '3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '2rem',
  },
  useCaseTitle: {
    fontSize: '1.3rem',
    fontWeight: 700,
    color: colors.gray900,
    margin: 0,
  },
  useCaseDescription: {
    color: colors.gray700,
    lineHeight: 1.625,
    margin: 0,
  },

  // CTA Section
  cta: {
    padding: '8rem 1.5rem',
    background: colors.gray900,
    position: 'relative',
    overflow: 'hidden',
  },
  ctaContainer: {
    maxWidth: '64rem',
    margin: '0 auto',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
    position: 'relative',
    zIndex: 10,
  },
  ctaTitle: {
    fontSize: '4.5rem',
    fontWeight: 700,
    color: colors.white,
    margin: 0,
  },
  ctaTitleGradient: {
    background: gradients.text,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  ctaDescription: {
    fontSize: '1.25rem',
    color: colors.gray300,
    maxWidth: '42rem',
    margin: '0 auto',
  },
  ctaButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.5rem',
    justifyContent: 'center',
  },
  ctaPrimaryButton: {
    background: gradients.primary,
    color: colors.white,
    padding: '1.5rem 3rem',
    borderRadius: '9999px',
    fontWeight: 700,
    fontSize: '1.125rem',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 25px 50px -12px rgb(0 0 0 / 0.25)',
    transition: 'transform 0.2s',
  },
  ctaSecondaryButton: {
    background: colors.white,
    color: colors.gray900,
    padding: '1.5rem 3rem',
    borderRadius: '9999px',
    fontWeight: 700,
    fontSize: '1.125rem',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1)',
    transition: 'background 0.2s',
  },
  ctaBlur1: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '24rem',
    height: '24rem',
    background: colors.indigo600,
    filter: 'blur(150px)',
    opacity: 0.2,
  },
  ctaBlur2: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '24rem',
    height: '24rem',
    background: colors.purple600,
    filter: 'blur(150px)',
    opacity: 0.2,
  },

  // Footer
  footer: {
    padding: '3rem 1.5rem',
    background: colors.white,
    borderTop: `1px solid ${colors.gray200}`,
  },
  footerContainer: {
    maxWidth: '80rem',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2rem',
  },
  footerLogo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  footerLogoIcon: {
    width: '2.5rem',
    height: '2.5rem',
    background: gradients.primary,
    borderRadius: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.25rem',
    color: colors.white,
  },
  footerLogoText: {
    fontSize: '1.25rem',
    fontWeight: 700,
    letterSpacing: '-0.025em',
    color: colors.gray900,
  },
  footerLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2rem',
    fontSize: '0.875rem',
    fontWeight: 600,
    color: colors.gray600,
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerLink: {
    color: colors.gray600,
    textDecoration: 'none',
    transition: 'color 0.2s',
  },
  footerDot: {
    color: colors.gray300,
  },
  footerCopyright: {
    fontSize: '0.75rem',
    color: colors.gray400,
    textAlign: 'center',
    margin: 0,
  },
};

const features = [
  { icon: DollarSign, title: 'Fixed Amount Fees', description: 'Add flat fees like $5 handling charges or $2.99 processing fees. Perfect for consistent costs.' },
  { icon: Percent, title: 'Percentage-Based', description: 'Add percentage surcharges like 3% payment processing fees that scale with order value.' },
  { icon: Layers, title: 'Native Integration', description: 'Fees display as standard line items in checkout summary. Looks built-in, not bolted on.' },
  { icon: ShieldCheck, title: 'Persistent & Reliable', description: 'Fees survive page refreshes and work seamlessly across all checkout steps. Zero glitches.' },
];

const steps = [
  { number: '01', icon: Download, title: 'Install from App Store', description: 'Find Checkout Fees in the BigCommerce App Marketplace and click install. One-click authorization connects to your store instantly.' },
  { number: '02', icon: Settings, title: 'Configure Your Fees', description: 'Choose fixed amount ($5.00) or percentage (3%), set the fee name, and customize the display label. Save your settings.' },
  { number: '03', icon: CheckCircle, title: 'Fees Display Automatically', description: 'Your custom fees appear immediately in checkout as native line items. Works across all checkout steps, cart page, and order confirmation.' },
];

const useCases = [
  { icon: CreditCard, title: 'Payment Processing Surcharges', description: 'Add 3% credit card processing fees to offset merchant account costs. Transparent pricing for customers, protected margins for you.' },
  { icon: Package, title: 'Handling & Packaging Fees', description: 'Charge $5 handling fees for special packaging, fragile items, or oversized products. Cover real fulfillment costs.' },
  { icon: Globe, title: 'Import & Tariff Fees', description: 'Apply tariff fees to imported product categories. Keep pricing transparent while covering cross-border costs.' },
  { icon: AlertTriangle, title: 'Hazmat & Special Handling', description: 'Charge $10 for hazardous materials like batteries or chemicals. Cover compliance and specialized shipping requirements.' },
  { icon: Box, title: 'Oversized & Heavy Items', description: 'Add surcharges for oversized or heavy product categories. Cover extra shipping and handling costs automatically.' },
  { icon: Tag, title: 'Brand-Specific Fees', description: 'Apply fees to specific brands in your catalog. Perfect for vendor chargebacks or brand licensing costs.' },
  { icon: Folder, title: 'Category-Specific Fees', description: 'Target fees to specific product categories. Ideal for departments with different handling or compliance requirements.' },
  { icon: Users, title: 'Customer Group Fees', description: 'Create fees for specific customer groups like wholesale, VIP, or retail. Different pricing tiers for different customers.' },
  { icon: Monitor, title: 'Channel-Specific Fees', description: 'Apply fees to specific sales channels. Different fee structures for web, mobile, or marketplace orders.' },
  { icon: Leaf, title: 'Environmental & Compliance', description: 'Charge eco-fees for recycling programs or compliance fees for regulated products. Stay compliant and transparent.' },
  { icon: Zap, title: 'Per-Product Surcharges', description: 'Multiply fees by product quantity. Perfect for per-item handling, insurance, or processing charges.' },
  { icon: Percent, title: 'Percentage-Based Fees', description: 'Calculate fees as a percentage of subtotal, grand total, or amount due. Scales automatically with order value.' },
];

function LandingPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleInstall = () => {
    window.open('https://www.bigcommerce.com/apps/checkout-fees-by-prangano/', '_blank');
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <GlobalStyles />
      <div style={styles.page}>
        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && (
          <div style={styles.mobileMenu}>
            <div style={styles.mobileMenuHeader}>
              <div style={styles.logo}>
                <img src="/logo-checkout-fees.png" alt="Checkout Fees" style={{ height: '42px' }} />
              </div>
              <button style={styles.mobileMenuClose} onClick={closeMobileMenu}>
                <X size={28} color={colors.gray900} />
              </button>
            </div>
            <div style={styles.mobileMenuLinks}>
              <a href="#features" style={styles.mobileMenuLink} onClick={closeMobileMenu}>Features</a>
              <a href="#how-it-works" style={styles.mobileMenuLink} onClick={closeMobileMenu}>How It Works</a>
              <a href="#use-cases" style={styles.mobileMenuLink} onClick={closeMobileMenu}>Use Cases</a>
              <a href="/support" style={styles.mobileMenuLink} onClick={closeMobileMenu}>Documentation</a>
            </div>
            <a href="/support#contact" style={styles.mobileMenuButton} onClick={closeMobileMenu}>Support</a>
          </div>
        )}

        {/* Hero Section */}
        <section style={styles.hero}>
          <div style={styles.heroContainer}>
            {/* Navigation */}
            <nav style={styles.nav}>
              <div style={styles.navInner}>
                <div style={styles.logo}>
                  <img src="/logo-checkout-fees.png" alt="Checkout Fees" style={{ height: '42px' }} />
                </div>

                {/* Desktop Navigation */}
                {!isMobile && (
                  <>
                    <div style={styles.navLinks}>
                      <a href="#features" style={styles.navLink}>Features</a>
                      <a href="#how-it-works" style={styles.navLink}>How It Works</a>
                      <a href="#use-cases" style={styles.navLink}>Use Cases</a>
                    </div>
                    <div style={styles.navRight}>
                      <a href="/support" style={styles.navLink}>Documentation</a>
                      <a href="/support#contact" style={{ ...styles.navButton, textDecoration: 'none' }}>Support</a>
                    </div>
                  </>
                )}

                {/* Mobile Hamburger */}
                {isMobile && (
                  <button style={{ ...styles.hamburger, display: 'block' }} onClick={() => setMobileMenuOpen(true)}>
                    <Menu size={28} color={colors.gray900} />
                  </button>
                )}
              </div>
            </nav>

            <div style={{
              ...styles.heroGrid,
              ...(isMobile && {
                gridTemplateColumns: '1fr',
                gap: '2rem',
                marginTop: '5rem',
              })
            }}>
              {/* Left Content */}
              <div style={styles.heroLeft}>
                {/* Uncomment when you have subscribers or verification
                <div style={styles.badges}>
                  <div style={styles.verifiedBadge}>
                    <CheckCircle size={16} /> BigCommerce Verified
                  </div>
                  <div style={styles.installsBadge}>
                    <div style={styles.pulseDot}></div>
                    Active Installations: 500+
                  </div>
                </div>
                */}

                <h1 style={{
                  ...styles.heroTitle,
                  ...(isMobile && { fontSize: '42px' })
                }}>
                  <BigCommerceLogo height={isMobile ? 35 : 50} color="#000" /><br />
                  Checkout Fees
                </h1>

                <div style={styles.heroContent}>
                  <p style={styles.heroDescription}>
                    Easily add processing fees, handling charges, tariffs, product charges, percentage-based surcharges, and more to your BigCommerce checkout
                  </p>

                  <div style={styles.featureRow}>
                    <div style={styles.featureIcon}>
                      <Zap size={20} color={colors.indigo600} />
                    </div>
                    <p style={styles.featureText}>
                      Fees display as native line items<br />
                      <span style={styles.featureSubtext}>No coding. Instant setup. Fees are permanently recorded in order emails and order history, perfect for accounting, tax reporting, and customer records.</span>
                    </p>
                  </div>

                  <div style={{
                    ...styles.heroButtons,
                    ...(isMobile && { justifyContent: 'center' })
                  }}>
                    <a href="#how-it-works" style={{ ...styles.primaryButton, textDecoration: 'none' }}>See How It Works</a>
                    {/* <button style={styles.primaryButton} onClick={handleInstall}>Install on BigCommerce</button> */}
                  </div>
                </div>
              </div>

              {/* Right Content - Order Summary */}
              <div style={{
                ...styles.heroRight,
                ...(isMobile && { justifyContent: 'center' })
              }}>
                <div style={{
                  ...styles.orderCard,
                  ...(isMobile && { width: '100%', maxWidth: '320px' })
                }}>
                  <div style={styles.orderCardInner}>
                    <div style={styles.orderHeader}>
                      <span style={styles.orderTitle}>Order Summary</span>
                      <ShoppingBag size={20} color={colors.gray400} />
                    </div>

                    <div style={styles.orderLines}>
                      <div style={styles.orderLine}>
                        <span style={styles.orderLabel}>Subtotal</span>
                        <span style={styles.orderValue}>$149.99</span>
                      </div>
                      <div style={styles.orderLine}>
                        <span style={styles.orderLabel}>Shipping</span>
                        <span style={styles.orderValue}>$12.00</span>
                      </div>
                      <div style={styles.orderLine}>
                        <span style={styles.orderLabel}>Processing Fee</span>
                        <span style={styles.orderValue}>$4.50</span>
                      </div>
                      <div style={styles.orderLine}>
                        <span style={styles.orderLabel}>Tax</span>
                        <span style={styles.orderValue}>$13.22</span>
                      </div>
                    </div>

                    <div style={styles.orderTotal}>
                      <span style={styles.totalLabel}>Total</span>
                      <span style={styles.totalValue}>$179.71</span>
                    </div>

                    <button style={styles.completeButton}>Complete Order</button>
                  </div>
                </div>

                {/* Floating Pills - Hidden on mobile */}
                {!isMobile && (
                  <>
                    <div style={{ ...styles.floatingPill, ...styles.fixedRatePill }}>
                      <div style={styles.checkIcon}>
                        <DollarSign size={12} color={colors.green600} />
                      </div>
                      <span>Fixed rate fees</span>
                    </div>
                    <div style={{ ...styles.floatingPill, ...styles.percentPill }}>
                      <div style={styles.checkIcon}>
                        <Percent size={12} color={colors.green600} />
                      </div>
                      <span>Percentage based fees</span>
                    </div>
                    <div style={{ ...styles.floatingPill, ...styles.persistentPill }}>
                      <RefreshCw size={16} color={colors.indigo600} />
                      <span>Persistent</span>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Decorative blurs */}
            <div style={styles.blur1}></div>
            <div style={styles.blur2}></div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" style={{
          ...styles.section,
          ...(isMobile && { padding: '4rem 3rem' })
        }}>
          <div style={styles.sectionContainer}>
            <div style={styles.sectionHeader}>
              <div style={styles.sectionBadge}>
                <span style={styles.sectionBadgeNumber}>1</span>
                <span style={styles.sectionBadgeText}>Core Features</span>
              </div>
              <h2 style={{
                ...styles.sectionTitle,
                ...(isMobile && { fontSize: '2rem' })
              }}>
                Flexible Fee <span style={styles.sectionTitleMuted}>Options</span>
              </h2>
              <p style={styles.sectionDescription}>
                Add any type of fee to your checkout with complete control over amount, type, and display
              </p>
            </div>

            <div style={{
              ...styles.featuresGrid,
              ...(isMobile && { gridTemplateColumns: '1fr', gap: '1.5rem' })
            }}>
              {features.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div key={index} style={styles.featureCard}>
                    <div style={styles.featureCardIcon}>
                      <IconComponent size={28} color={colors.white} />
                    </div>
                    <h3 style={styles.featureCardTitle}>{feature.title}</h3>
                    <p style={styles.featureCardDescription}>{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section id="how-it-works" style={{
          ...styles.sectionGray,
          ...(isMobile && { padding: '4rem 3rem' })
        }}>
          <div style={styles.sectionContainer}>
            <div style={styles.sectionHeader}>
              <div style={{ ...styles.sectionBadge, background: colors.white, border: `1px solid ${colors.gray200}` }}>
                <span style={styles.sectionBadgeNumber}>2</span>
                <span style={{ ...styles.sectionBadgeText, color: colors.gray700 }}>Setup Process</span>
              </div>
              <h2 style={{
                ...styles.sectionTitle,
                ...(isMobile && { fontSize: '2rem' })
              }}>
                Simple <span style={styles.sectionTitleMuted}>3-Step</span> Setup
              </h2>
              <p style={styles.sectionDescription}>
                Get custom fees running in your checkout in under 5 minutes
              </p>
            </div>

            <div style={styles.stepsContainer}>
              {steps.map((step, index) => {
                const IconComponent = step.icon;
                return (
                  <div key={index} style={{
                    ...styles.step,
                    ...(isMobile && { flexDirection: 'column', gap: '1rem' })
                  }}>
                    <span style={{
                      ...styles.stepNumber,
                      ...(isMobile && { fontSize: '3rem' })
                    }}>{step.number}</span>
                    <div style={styles.stepContent}>
                      <div style={{
                        ...styles.stepHeader,
                        ...(isMobile && { flexDirection: 'column', alignItems: 'flex-start', gap: '0.75rem' })
                      }}>
                        <div style={styles.stepIcon}>
                          <IconComponent size={24} color={colors.white} />
                        </div>
                        <h3 style={styles.stepTitle}>{step.title}</h3>
                      </div>
                      <p style={styles.stepDescription}>{step.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Use Cases Section */}
        <section id="use-cases" style={{
          ...styles.section,
          ...(isMobile && { padding: '4rem 3rem' })
        }}>
          <div style={styles.sectionContainer}>
            <div style={styles.sectionHeader}>
              <div style={styles.sectionBadge}>
                <span style={styles.sectionBadgeNumber}>3</span>
                <span style={styles.sectionBadgeText}>Common Scenarios</span>
              </div>
              <h2 style={{
                ...styles.sectionTitle,
                ...(isMobile && { fontSize: '2rem' })
              }}>
                Popular <span style={styles.sectionTitleMuted}>Use Cases</span>
              </h2>
              <p style={styles.sectionDescription}>
                See how merchants use custom fees to cover costs and maintain profitability
              </p>
            </div>

            <div style={{
              ...styles.useCasesGrid,
              ...(isMobile && { gridTemplateColumns: '1fr', gap: '1.5rem' })
            }}>
              {useCases.map((useCase, index) => {
                const IconComponent = useCase.icon;
                return (
                  <div key={index} style={styles.useCaseCard}>
                    <div style={styles.useCaseIcon}>
                      <IconComponent size={32} color={colors.indigo600} />
                    </div>
                    <h3 style={styles.useCaseTitle}>{useCase.title}</h3>
                    <p style={styles.useCaseDescription}>{useCase.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section style={{
          ...styles.cta,
          ...(isMobile && { padding: '4rem 3rem' })
        }}>
          <div style={styles.ctaContainer}>
            <h2 style={{
              ...styles.ctaTitle,
              ...(isMobile && { fontSize: '2.5rem' })
            }}>
              Ready to Add <span style={styles.ctaTitleGradient}>Custom Fees?</span>
            </h2>
            <p style={styles.ctaDescription}>
              Install Checkout Fees from the BigCommerce App Store and start adding fees to your checkout in minutes
            </p>
            <div style={{
              ...styles.ctaButtons,
              ...(isMobile && { flexDirection: 'column', gap: '1rem' })
            }}>
              <button style={{
                ...styles.ctaPrimaryButton,
                ...(isMobile && { width: '100%', padding: '1rem 2rem' })
              }} onClick={handleInstall}>Install on BigCommerce</button>
              <button style={{
                ...styles.ctaSecondaryButton,
                ...(isMobile && { width: '100%', padding: '1rem 2rem' })
              }} onClick={() => window.location.href = '/support'}>View Documentation</button>
            </div>
          </div>
          <div style={styles.ctaBlur1}></div>
          <div style={styles.ctaBlur2}></div>
        </section>

        {/* Footer */}
        <footer style={styles.footer}>
          <div style={styles.footerContainer}>
            <div style={styles.footerLogo}>
              <img src="/logo-checkout-fees.png" alt="Checkout Fees" style={{ height: '40px' }} />
            </div>
            <div style={{
              ...styles.footerLinks,
              ...(isMobile && { flexDirection: 'column', gap: '1rem' })
            }}>
              <a href="https://www.bigcommerce.com/apps/checkout-fees-by-prangano/" target="_blank" rel="noopener noreferrer" style={styles.footerLink}>BigCommerce App Store</a>
              {!isMobile && <span style={styles.footerDot}>•</span>}
              <a href="/support" style={styles.footerLink}>Documentation</a>
              {!isMobile && <span style={styles.footerDot}>•</span>}
              <a href="/support#contact" style={styles.footerLink}>Support</a>
              {!isMobile && <span style={styles.footerDot}>•</span>}
              <a href="/privacy" style={styles.footerLink}>Privacy Policy</a>
              {!isMobile && <span style={styles.footerDot}>•</span>}
              <a href="/terms" style={styles.footerLink}>Terms of Service</a>
            </div>
            <p style={styles.footerCopyright}>© 2026 Checkout Fees. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </>
  );
}

export default LandingPage;
